import { render, staticRenderFns } from "./GroupSessionLayout.vue?vue&type=template&id=3ffdcc3d&scoped=true&"
import script from "./GroupSessionLayout.vue?vue&type=script&lang=ts&"
export * from "./GroupSessionLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffdcc3d",
  null
  
)

export default component.exports